(function(){
    // Desktop mega-menu tab switching
    function selectMegaTab(e){
      var cat = e.target.closest('.mega__cat');
      if(!cat) return;
      var mega = cat.closest('.mega');
      if(!mega) return;
      var idx = cat.getAttribute('data-mega-tab');
      mega.querySelectorAll('.mega__cat').forEach(function(c){ c.classList.toggle('is-active', c.getAttribute('data-mega-tab') === idx); });
      mega.querySelectorAll('.mega__panel').forEach(function(p){ p.classList.toggle('is-active', p.getAttribute('data-mega-panel') === idx); });
      if(window.__dhHydrateMenu) window.__dhHydrateMenu(mega.querySelector('.mega__panel.is-active'));
    }
    document.addEventListener('mouseover', selectMegaTab, { passive: true });
    document.addEventListener('focusin', selectMegaTab);

    // Collapsible search bar (toggled by the search icon) + predictive results
    var searchBar = document.getElementById('HeaderSearch');
    var searchResults = document.getElementById('HeaderSearchResults');
    var searchInput = searchBar ? searchBar.querySelector('input') : null;
    var searchURL = searchResults && searchResults.getAttribute('data-search-url') || '/search';
    function searchLabel(name, fallback){ return searchResults && searchResults.getAttribute('data-' + name + '-label') || fallback; }
    function searchMessage(name, fallback, query, strong){
      return esc(searchLabel(name, fallback)).replace('__QUERY__', function(){ return strong ? '<strong>' + esc(query) + '</strong>' : esc(query); });
    }
    document.addEventListener('click', function(e){
      var st = e.target.closest('[data-search-toggle]');
      if(st){
        e.preventDefault();
        if(searchBar){
          searchBar.hidden = !searchBar.hidden;
          st.setAttribute('aria-expanded', searchBar.hidden ? 'false' : 'true');
          if(searchBar.hidden){ if(searchResults) searchResults.innerHTML = ''; }
          else { if(searchInput) searchInput.focus(); }
        }
      }
    });

    function fmtMoney(p){ var n = parseFloat(p); return isNaN(n) ? '' : '₹' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
    function esc(s){ return (s || '').replace(/[&<>"]/g, function(c){ return { '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;' }[c]; }); }

    // Search thumbnails render at 54px; request matching Shopify CDN sizes.
    function searchImageURL(src, width){
      try {
        var url = new URL(src, window.location.origin);
        if(url.hostname === 'cdn.shopify.com' ||
          (url.hostname === window.location.hostname && url.pathname.indexOf('/cdn/shop/') === 0)){
          url.searchParams.set('width', width);
          return url.href;
        }
      } catch(e){}
      return src;
    }

    // ---- Typo-tolerant vocabulary (seeded from collections, harvested from results) ----
    var VOCAB = {};
    (function(){
      var raw = (window.DH_SEARCH_VOCAB || '');
      try { var extra = sessionStorage.getItem('dh_vocab'); if(extra) raw += ' ' + extra; } catch(e){}
      raw.toLowerCase().split(/[^a-z0-9]+/).forEach(function(w){ if(w.length >= 3) VOCAB[w] = 1; });
    })();
    function harvestVocab(titles){
      var add = [];
      titles.forEach(function(t){ (t || '').toLowerCase().split(/[^a-z0-9]+/).forEach(function(w){ if(w.length >= 3 && !VOCAB[w]){ VOCAB[w] = 1; add.push(w); } }); });
      if(add.length){ try { var cur = sessionStorage.getItem('dh_vocab') || ''; sessionStorage.setItem('dh_vocab', (cur + ' ' + add.join(' ')).slice(-25000)); } catch(e){} }
    }
    function editDist(a, b){ // Damerau-Levenshtein (handles swaps/typos)
      var m = a.length, n = b.length; if(!m) return n; if(!n) return m;
      var prev = [], cur = [], i, j;
      for(j = 0; j <= n; j++) prev[j] = j;
      for(i = 1; i <= m; i++){
        cur[0] = i;
        for(j = 1; j <= n; j++){
          var cost = a.charCodeAt(i-1) === b.charCodeAt(j-1) ? 0 : 1;
          cur[j] = Math.min(prev[j] + 1, cur[j-1] + 1, prev[j-1] + cost);
          if(i > 1 && j > 1 && a.charCodeAt(i-1) === b.charCodeAt(j-2) && a.charCodeAt(i-2) === b.charCodeAt(j-1)){ cur[j] = Math.min(cur[j], prev[j-1] + 1); }
        }
        var tmp = prev; prev = cur; cur = tmp;
      }
      return prev[n];
    }
    function correctToken(tok){
      if(tok.length < 3 || VOCAB[tok]) return tok;
      var max = tok.length <= 4 ? 1 : 2, best = tok, bestD = max + 1, w;
      for(w in VOCAB){
        if(Math.abs(w.length - tok.length) > max) continue;
        if(w[0] !== tok[0] && tok.length > 4) continue; // keep first letter for longer words
        var d = editDist(tok, w);
        if(d < bestD){ bestD = d; best = w; if(d === 0) break; }
      }
      if(bestD <= max) return best;
      // prefix fallback for harder typos (e.g. rudrek -> rudraksha)
      var need = Math.max(4, Math.ceil(tok.length * 0.6)), pbest = null, plen = 0;
      for(w in VOCAB){
        var k = 0, L = Math.min(w.length, tok.length);
        while(k < L && w.charAt(k) === tok.charAt(k)) k++;
        if(k >= need && (k > plen || (k === plen && pbest && w.length < pbest.length))){ plen = k; pbest = w; }
      }
      return pbest || tok;
    }
    function correctQuery(q){ return q.split(/\s+/).map(correctToken).join(' '); }

    function visibleProducts(res){
      return (res.products || []).filter(function(p){ return !window.DHIsDIYBead || !window.DHIsDIYBead(p); });
    }

    function visibleCollections(res){
      return (res.collections || []).filter(function(c){
        if(c.handle === 'diy-beads') return false;
        var path = String(c.url || '').split(/[?#]/)[0];
        try { path = new URL(c.url, window.location.origin).pathname; } catch(e){}
        return !/\/collections\/diy-beads\/?$/.test(path);
      });
    }

    function renderSearch(q, data, original){
      if(!searchResults) return;
      var res = (data && data.resources && data.resources.results) || {};
      var visible = visibleProducts(res);
      var products = visible.slice(0, 6);
      var collections = visibleCollections(res).slice(0, 8);
      harvestVocab(visible.map(function(p){ return p.title; }).concat(visibleCollections(res).map(function(c){ return c.title; })));
      var html = '';
      if(original && original.toLowerCase() !== q.toLowerCase()){ html += '<div class="hsr__correct">' + searchMessage('showing', 'Showing results for __QUERY__', q, true) + '</div>'; }
      if(products.length){
        html += '<div class="hsr__heading">' + esc(searchLabel('products', 'Products')) + '</div>';
        products.forEach(function(p){
          html += '<a class="hsr__product" href="' + p.url + '">' +
            (p.image ? '<img src="' + esc(searchImageURL(p.image, 108)) + '" srcset="' +
              esc(searchImageURL(p.image, 54)) + ' 54w, ' +
              esc(searchImageURL(p.image, 108)) + ' 108w, ' +
              esc(searchImageURL(p.image, 162)) + ' 162w" sizes="54px" width="54" height="54" alt="" loading="lazy" decoding="async">' : '<span class="hsr__ph"></span>') +
            '<span><span class="t">' + esc(p.title) + '</span><span class="p">' + fmtMoney(p.price) + '</span></span></a>';
        });
      }
      if(collections.length){
        html += '<div class="hsr__heading">' + esc(searchLabel('collections', 'Collections')) + '</div>';
        collections.forEach(function(c){ html += '<a class="hsr__coll" href="' + c.url + '">' + esc(c.title) + '</a>'; });
      }
      if(!products.length && !collections.length){
        html = '<div class="hsr__empty">' + searchMessage('empty', 'No results for "__QUERY__"', original || q) + '</div>';
      } else {
        html += '<a class="hsr__viewall" href="' + searchURL + '?q=' + encodeURIComponent(q) + '">' + searchMessage('viewall', 'View all results for "__QUERY__"', q) + ' &rarr;</a>';
      }
      searchResults.innerHTML = html;
    }

    function suggestURL(q){ return searchURL + '/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection&resources[limit]=10&resources[limit_scope]=each'; }
    if(searchInput){
      var sTimer, seq = 0;
      searchInput.addEventListener('input', function(){
        clearTimeout(sTimer);
        var q = searchInput.value.trim();
        var mySeq = ++seq;
        if(q.length < 1){ if(searchResults) searchResults.innerHTML = ''; return; }
        sTimer = setTimeout(function(){
          fetch(suggestURL(q)).then(function(r){ return r.json(); }).then(function(d){
            if(mySeq !== seq) return; // a newer keystroke superseded this one
            var rr = (d && d.resources && d.resources.results) || {};
            var got = visibleProducts(rr).length + visibleCollections(rr).length;
            if(got > 0){ renderSearch(q, d); return; }
            // No results — try a spelling correction and re-search
            var corrected = correctQuery(q.toLowerCase());
            if(corrected && corrected !== q.toLowerCase()){
              fetch(suggestURL(corrected)).then(function(r){ return r.json(); }).then(function(d2){
                if(mySeq === seq) renderSearch(corrected, d2, q);
              }).catch(function(){});
            } else {
              renderSearch(q, d);
            }
          }).catch(function(){});
        }, 150);
      });
    }

    // Mobile slide-in menu + two-level accordion
    var mnav = document.getElementById('MobileNav');
    if(!mnav) return;
    function openNav(){ mnav.classList.add('is-open'); mnav.setAttribute('aria-hidden','false'); document.documentElement.classList.add('mnav-open'); }
    function closeNav(){ mnav.classList.remove('is-open'); mnav.setAttribute('aria-hidden','true'); document.documentElement.classList.remove('mnav-open'); }
    document.addEventListener('click', function(e){
      if(e.target.closest('[data-mnav-open]')){ e.preventDefault(); openNav(); return; }
      if(e.target.closest('[data-mnav-close]')){ closeNav(); return; }
      var a1 = e.target.closest('[data-acc1]');
      if(a1){
        e.preventDefault();
        var li = a1.closest('.mnav2__cat');
        var willOpen = !li.classList.contains('is-open');
        // close every open category (accordion: only one open at a time)
        mnav.querySelectorAll('.mnav2__cat.is-open').forEach(function(c){
          c.classList.remove('is-open');
          var p = c.querySelector('.pm'); if(p) p.textContent = '+';
          c.querySelectorAll('.mnav2__sub.is-open').forEach(function(s){ s.classList.remove('is-open'); });
        });
        if(willOpen){ li.classList.add('is-open'); var pm = a1.querySelector('.pm'); if(pm) pm.textContent = '−'; }
        return;
      }
      var a2 = e.target.closest('[data-acc2]');
      if(a2){
        e.preventDefault();
        var sub = a2.closest('.mnav2__sub');
        var willOpen = !sub.classList.contains('is-open');
        // close other open sub-sections in the same category
        sub.parentElement.querySelectorAll('.mnav2__sub.is-open').forEach(function(s){ s.classList.remove('is-open'); });
        if(willOpen) sub.classList.add('is-open');
        return;
      }
    });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ closeNav(); if(searchBar && !searchBar.hidden){ searchBar.hidden = true; var stb = document.querySelector('[data-search-toggle]'); if(stb) stb.setAttribute('aria-expanded','false'); } } });
  })();
